export const approvalspage = {
  approvalspage: {
  pageTitle: 'Approvals Page',
  table: {
    header: {
      type: 'Type',
      user: 'User',
      date: 'Date',
      status: 'Status',
      actions: 'Actions',
    },
  },
  noContent: 'No Content',
  checkDetails: 'Check Details',
  loading: 'Loading...',
  error: 'An error occurred while loading the data.',
  modalRegisterDetails: {
    contactInformation: 'Contact Information',
    companyWorkAddress: 'Company Work Address',
    accountDetails: 'Account Details',
    role: 'Role',
    linkedAccounts: 'Linked Accounts',
  },
  formAccountNumbers: {
    accountNumber: 'Account Number',
    add: 'Add',
    validate: 'Validate',
    remove: 'Remove',
    accountNumberAlreadyInList: 'Account number already in your list.',
    maxAccountNumbers: 'You can only add up to 10 account numbers.',
    accountNumberValidated: 'Account number validated.',
    accountNumberAdded: 'Account number added to your list.',
    accountNumberRemoved: 'Account number removed from your list.',
    invalidAccountNumber: 'The entered account number is not valid or the account is not yet transitioned for use at <a href="marathonelectric.com" target="_blank">marathonelectric.com</a>',
  },
  formAccountDetails: {
    companyBillingAddress: 'Company Billing Address',
    billingAddressIsEqualWorkAddress: 'Billing address is the same as my work address',
    productCategory: 'Product Category',
    productCategoriesOfInterest: 'Product categories of interest',
    selectOption: 'Select an option',
  },
  modalRoleDetails: {
    nameOfApplicant: 'Name of the applicant',
    currentRole: 'Current Role',
    requestedRole: 'Requested Role',
    currentAccounts: 'Current Accounts',
    noLinkedAccount: 'No Linked Account',
    approvalAffectsAllAccounts: 'I understand that my approval affects all accounts.',
  },
  modalAccountDetails: {
    nameOfApplicant: 'Name of the applicant',
    requestedAccount: 'Requested Account',
    reason: 'Reason',
  },
  modalRequestActions: {
    approvalUser: 'Approval User',
    approvalDate: 'Approval Date',
    cancel: 'Cancel',
    deny: 'Deny',
    approve: 'Approve',
  },
}
};
